import React from 'react';


const Format1 = ({modifyForm}) => {
 
  const {
    financial_year = "2024-2025",
    static_fields = {
      line1: "",
      line2: "",
      line3: "",
      line4: "",
      line5: "",
      line6: "",
      line7: ""
    },
    prepared_by = "",
    verified_by = "",
    col1 = { name: "Shipment Number", value: "Field 1" },
    col2 = { name: "CN Date", value: "LR Date" },
    col3 = { name: "Description", value: "" },
    col4 = { name: "Invoice Number", value: "Invoice Number" },
    col11 = { name: "SE Number", value: "LR Number" }
  } = modifyForm || {};
  return (

   <>
    <style>
      {`@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

body {
  margin: 0px;
  font-family: "Roboto", sans-serif;
}

@page {
  margin: 0px;
}

.__invTemplate1 .__mainTab_reps {
  width: 100%;
  border: 1px solid #000;
  margin-bottom: 10px;
}

.__invTemplate1 .__inlineTables {
  width: 100%;
  border-collapse: collapse;
}

.__invTemplate1 .__inlineTables p {
  font-size: 10px;
  font-weight: 400;
  margin: 0px;
  line-height: 17px;
}

.__invTemplate1 .__vehTable {
  width: 100%;
  border-collapse: collapse;
}

.__invTemplate1 .__vehTable th,
.__invTemplate1 .__vehTable td {
  font-size: 10px;
  border: 1px solid #000;
  padding: 5px 5px;
  font-weight: 400;
}

.__invTemplate1 .__vehTable th:nth-child(1),
.__invTemplate1 .__vehTable td:nth-child(1) {
  border-left: none;
}

.__invTemplate1 .__vehTable th:last-child,
.__invTemplate1 .__vehTable td:last-child {
  border-right: none;
}

.__invTemplate1 .__vehTable td p {
  margin: 0;
  min-height: 10px;
}

.__invTemplate1 .__tfooterTab {
  width: 100%;
  min-height: 65px;
  border-collapse: collapse;
}

.__invTemplate1 .__tfooterTab td {
  font-size: 10px;
  vertical-align: bottom;
}

.__invTemplate1 .__tfooterTab td p {
  margin: 0px;
  line-height: 20px;
}

.sheet.padding-2mm_inv {
  padding: 2mm;
  background: white;
  page-break-after: always;
}

.sheet.padding-2mm_inv:last-child {
  page-break-after: auto;
}

.sheet-content.__invTemplate1 {
  transform-origin: top left;
  transition: transform 0.2s ease;
  width: 210mm;
  margin: 0 auto;
}

@media (max-width: 319px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(20% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 320px) and (max-width: 339px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(20% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 340px) and (max-width: 359px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(20% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 360px) and (max-width: 379px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(22% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 380px) and (max-width: 399px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(24% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 400px) and (max-width: 419px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(26% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 420px) and (max-width: 439px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(26% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 440px) and (max-width: 459px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(28% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 460px) and (max-width: 479px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(28.6% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 480px) and (max-width: 499px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(30% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 500px) and (max-width: 519px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(30% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 520px) and (max-width: 539px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(30% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 540px) and (max-width: 559px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(33.6% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 560px) and (max-width: 579px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(35% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 580px) and (max-width: 599px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(36% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 600px) and (max-width: 629px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(37.5% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 630px) and (max-width: 669px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(38.6% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 670px) and (max-width: 699px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(42% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 700px) and (max-width: 739px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(44% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 740px) and (max-width: 769px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(46% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (min-width: 770px) and (max-width: 799px) {
  .sheet-content.__invTemplate1 {
    transform: scale(calc(48% * 2)) !important;
    transform-origin: 5px 0px;
  }
}

@media (max-width: 767px) {
  .sheet-content.__invTemplate1 {
    margin: 0 auto;
  }
}

@media print {
  .sheet-content.__invTemplate1 {
    transform: scale(1) !important;
    width: 210mm;
  }

  .sheet.padding-2mm_inv {
    padding: 2mm;
  }

  @page {
    margin: 0px;
    size: A4 portrait;
  }
}`
}
    </style>
 <div className="sheet-content __invTemplate1">
      <section className="sheet padding-2mm_inv">
        <div id="printableArea221">
          <table className="__mainTab_reps" cellPadding="0" cellSpacing="0">
            <tbody>
              <tr>
                <td>
                  <table style={{ width: '100%', borderBottom: '1px solid #000' }}>
                    <thead>
                      <tr>
                        <th align="center" style={{ fontSize: '14px', padding: '2px', fontWeight: '600',textAlign:"center" }}>
                          { "CHOUBEY LOGISTICS PRIVATE LIMITED"}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table className="__inlineTables">
                    <tbody>
                      <tr>
                        <td align="center">
                          <p style={{ borderBottom: '1px solid #000' }}>
                            { "PLOT NO. 259, P K V SOCIETY, KATOL ROAD BY PASS, DHABA NAGPUR - 440023"}
                          </p>
                          <p style={{ borderBottom: '1px solid #000' }}>
                            FOR THE FINANCIAL YEAR {financial_year}
                          </p>
                          <p style={{ borderBottom: '1px solid #000', minHeight: '16px' }}>
                            {/* {static_fields.line3} */}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td>
                  <table className="__inlineTables">
                    <tbody>
                      <tr>
                        <td style={{ borderBottom: '1px solid #000', width: '43%' }}>
                          <p>{ "PHONE: 9823166667; 9372268000 MAIL ID: choubeytrans@gmail.com"}</p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000', width: '22%' }}>
                          <p>{ "GSTIN: 27AALCC9434G1ZD"}</p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000' }}>
                          <p>{ "SERVICE ACCOUNTING CODE: 996511"}</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ borderBottom: '1px solid #000', width: '43%' }}>
                          <p>{ "PAN: AALCC9434G"}</p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000', width: '22%' }}>
                          <p>DEPARTMENT: ACCOUNTS</p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000' }}>
                          <p>BRANCH: NAGPUR</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td style={{ paddingTop: '15px' }}>
                  <table className="__inlineTables">
                    <tbody>
                      <tr>
                        <td style={{ borderBottom: '1px solid #000', borderTop: '1px solid #000', width: '43%' }}>
                          <p>BILL TO: HALDIRAM FOOD INTERNATIONAL PVT. LTD.</p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000', borderTop: '1px solid #000', width: '22%' }}>
                          <p>GSTIN: 27AAACH3628L1ZG</p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000', borderTop: '1px solid #000' }}>
                          <p>BILL NO: HFIPL/2024-25/01</p>
                        </td>
                      </tr>

                      <tr>
                        <td style={{ borderBottom: '1px solid #000', width: '43%' }}>
                          <p></p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000', width: '22%' }}>
                          <p>VENDOR CODE:</p>
                        </td>

                        <td style={{ borderBottom: '1px solid #000' }}>
                          <p>BILL DATE: 00.00.0000</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td style={{ paddingTop: '15px' }}>
                  <table className="__vehTable">
                    <thead>
                      <tr>
                        <th align="left">{ col1?.name || "SHIPMENT NO"}</th>
                        <th>{col2?.name || "CN DATE"}</th>
                        <th>{col3.name || "DESCRIPTION"}</th>
                        <th>{col4.name || "INVOICE NO"}</th>
                        <th>ORIGIN</th>
                        <th>DESTINATION</th>
                        <th>VEHICLE NO</th>
                        <th>TYPE OF VEHICLE</th>
                        <th>PKG</th>
                        <th>WEIGHT (KG)</th>
                        <th>{col11.name || "SE NO"}</th>
                        <th>AMOUNT</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td><p></p></td>
                        <td align="right"><p></p></td>
                        <td align="right"><p></p></td>
                      </tr>
                    </tbody>

                    <tbody>
                      <td align="left" colSpan="12" style={{ fontWeight: '600' }}>
                        INWORDS RS. :
                      </td>
                    </tbody>

                    <tfoot>
                      <td align="left" colSpan="4">
                        CGST @ 2.5% =
                      </td>
                      <td align="left" colSpan="3">
                        SGST @ 2.5% =
                      </td>
                      <td align="left" colSpan="4">
                        TOTAL @ 5% =
                      </td>
                      <td align="left" colSpan="1"></td>
                    </tfoot>
                  </table>
                </td>
              </tr>

              <tr>
                <td style={{ paddingTop: '15px' }}>
                  <p style={{ fontSize: '9.5px', margin: '0', padding: '1px 2px' }}>
                {`1. ${static_fields.line1 || "Nagpur Jurisdiction Only"}.`}
                  </p>
                  <p style={{ fontSize: '9.5px', margin: '0', padding: '1px 2px' }}>
                    {`2. ${static_fields.line2 || "Payment should be made on due date or within 15 days of receipt of bill;else interest will be charged  @18%"}.`}
                  </p>
                  <p style={{ fontSize: '9.5px', margin: '0', padding: '1px 2px' }}>
                     {`3. ${static_fields.line3 || "Please pay A/c payee cheque in favor of CHOUBEY TRANSPORT SERVICE"}.`}
                  </p>
                  <p style={{ fontSize: '9.5px', margin: '0', padding: '1px 2px' }}>
                    {`4. ${static_fields.line4 || "In case of any discrepancy in the bill, the same should be brought to the notice of the company within 7 days in writing; otherwise, it shall be acceptable to you"}.`}
                  </p>
                  <p style={{ fontSize: '9.5px', margin: '0', padding: '1px 2px' }}>
                     {`5. ${static_fields.line5 || "We hereby certify that input tax credit or inputs, input services, and capital goods used for providing service of transportation have not been taken under the provision of the CGST/SGST/IGST/UTGST ACT-2017"}.`}
                  </p>
                  <p style={{ fontSize: '9.5px', margin: '0', padding: '1px 2px' }}>
                    {`6. ${static_fields.line6 || "GST ON GOODS TRANSPORT AGENCY IS APPLICABLE ON REVERSE CHARGE BASIS"}.`}
                    .
                  </p>
                  {static_fields.line7 && <p style={{ fontSize: '9.5px', margin: '0', padding: '1px 2px' }}>
                    {`7. ${static_fields.line7 || "GST ON GOODS TRANSPORT AGENCY IS APPLICABLE ON REVERSE CHARGE BASIS"}.`}
                    .
                  </p>}
                </td>
              </tr>

              <tr>
                <td style={{ paddingTop: '2.5em' }}>
                  <table className="__tfooterTab">
                    <tbody>
                      <tr>
                        <td align="center" style={{ width: '20%' }}>
                          <div>
                            <p>{prepared_by || "MR. SHUBHAM PANDEY"}</p>
                          </div>
                          <p>PREPARED BY</p>
                        </td>
                        <td
                          align="center"
                          style={{ width: '40%', padding: '0px 6em 0px 6em' }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>{verified_by ? verified_by.split(',')[0] : "MR. NITIN"}</p>
                            <p>{verified_by ? verified_by.split(',')[1] : "MR. DINESH"}</p>
                          </div>
                          <p>VERIFIED BY</p>
                        </td>
                        <td
                          style={{
                            width: '18%',
                            padding: '0px 10px 10px 10px',
                            border: '1px solid #000',
                            borderBottom: 'none',
                            borderRight: 'none',
                          }}
                          align="center"
                        >
                          <p>AUTHORISE SIGNATORY</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
   </>
    
  );
};

export default Format1;